import { put, call } from 'redux-saga/effects';
import { slabSearchApi, insuranceSlabCreateAPI, insuranceSlabUpdateAPI} from 'src/api/InsuranceSlabApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { buildSearchWithNoCase } from 'src/utils/CommonUtils';
import { INSURANCE_SLAB_ACTIONS } from '../actions/insuranceSlabActions';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(slabSearchApi, {
            where: buildSearchWithNoCase({
                where,
                fullTextSearch,
            }),
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });
        yield put({
            type: INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({ _id }) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(slabSearchApi, {
            where: {
                _id,
            },
            autopopulate: false,
        });
        if (!data || !data[0]) {
            yield put(headerShowAction({
                data: 'Unable to Edit, something went wrong',
            }));
        }

        yield put({
            type: INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    
    try {
        const {
            data: {
                data,
            },
        } = yield call(insuranceSlabCreateAPI, {
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Created',
        }));

        yield put({
            type: INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
    }
    catch (error) {
        console.error('LOG: insert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_UPSERT_ERROR,
        });
    }
}

function* update(slabId, payload) {
    try {
        
        yield call(insuranceSlabUpdateAPI, {
            slabId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));

        yield edit({ _id: slabId });
    }
    catch (error) {
        console.error('LOG: update error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_SEARCH, search),
    takeFirstSagaUtil(INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_UPSERT, upsert),
    takeFirstSagaUtil(INSURANCE_SLAB_ACTIONS.INSURANCE_SLAB_EDIT, edit),
];
